module.exports = __webpack_public_path__ + "static/media/02.707896f2.gif";